/*                                                                           */

import { DEV } from 'esm-env';

/**
 *
 *
 *
 */
export function experimental_async_required(name) {
	if (DEV) {
		const error = new Error(`experimental_async_required\nCannot use \`${name}(...)\` unless the \`experimental.async\` compiler option is \`true\`\nhttps:/*                                         */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                         */
	}
}

/**
 *
 *
 */
export function invalid_default_snippet() {
	if (DEV) {
		const error = new Error(`invalid_default_snippet\nCannot use \`{@render children(...)}\` if the parent component uses \`let:\` directives. Consider using a named snippet instead\nhttps:/*                                     */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                     */
	}
}

/**
 *
 *
 */
export function invalid_snippet_arguments() {
	if (DEV) {
		const error = new Error(`invalid_snippet_arguments\nA snippet function was passed invalid arguments. Snippets should only be instantiated via \`{@render ...}\`\nhttps:/*                                       */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                       */
	}
}

/**
 *
 *
 *
 */
export function lifecycle_outside_component(name) {
	if (DEV) {
		const error = new Error(`lifecycle_outside_component\n\`${name}(...)\` can only be used during component initialisation\nhttps:/*                                         */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                         */
	}
}

/**
 *
 *
 */
export function missing_context() {
	if (DEV) {
		const error = new Error(`missing_context\nContext was not set in a parent component\nhttps:/*                             */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                             */
	}
}

/**
 *
 *
 */
export function snippet_without_render_tag() {
	if (DEV) {
		const error = new Error(`snippet_without_render_tag\nAttempted to render a snippet without a \`{@render}\` block. This would cause the snippet code to be stringified instead of its content being rendered to the DOM. To fix this, change \`{snippet}\` to \`{@render snippet()}\`.\nhttps:/*                                        */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                        */
	}
}

/**
 *
 *
 *
 */
export function store_invalid_shape(name) {
	if (DEV) {
		const error = new Error(`store_invalid_shape\n\`${name}\` is not a store with a \`subscribe\` method\nhttps:/*                                 */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                 */
	}
}

/**
 *
 *
 */
export function svelte_element_invalid_this_value() {
	if (DEV) {
		const error = new Error(`svelte_element_invalid_this_value\nThe \`this\` prop on \`<svelte:element>\` must be a string, if defined\nhttps:/*                                               */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                               */
	}
}